function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconProfileStroke = function SvgIconProfileStroke(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10.5,
    stroke: props.color
  }), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "m4 19.5 3.717-3.253A1 1 0 0 1 8.376 16h7.248a1 1 0 0 1 .659.247L20 19.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10.5,
    r: 3,
    stroke: props.color
  }));
};
export default SvgIconProfileStroke;